import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

const qs = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

// ---- Rooms ----
export const createExamRoom = async (data) => {
  const res = await axiosInstance.post("/exam-seating/rooms/create", data);
  return res.data;
};

export const getAllExamRooms = async (filters = {}) => {
  const res = await axiosInstance.get(`/exam-seating/rooms/all${qs(filters)}`);
  return res.data;
};

export const getExamRoomById = async (id) => {
  const res = await axiosInstance.get(`/exam-seating/rooms/${id}`);
  return res.data;
};

export const updateExamRoom = async (id, data) => {
  const res = await axiosInstance.put(`/exam-seating/rooms/update/${id}`, data);
  return res.data;
};

export const deleteExamRoom = async (id) => {
  const res = await axiosInstance.delete(`/exam-seating/rooms/delete/${id}`);
  return res.data;
};

// ---- Seating plans ----
export const createSeatingPlan = async (data) => {
  const res = await axiosInstance.post("/exam-seating/create", data);
  return res.data;
};

export const getAllSeatingPlans = async (filters = {}) => {
  const res = await axiosInstance.get(`/exam-seating/all${qs(filters)}`);
  return res.data;
};

export const getSeatingPlanById = async (id) => {
  const res = await axiosInstance.get(`/exam-seating/${id}`);
  return res.data;
};

export const getSeatingPlanBySchedule = async (scheduleId) => {
  const res = await axiosInstance.get(
    `/exam-seating/by-schedule/${scheduleId}`
  );
  return res.data;
};

export const getStudentsForSeating = async (scheduleId, filters = {}) => {
  const res = await axiosInstance.get(
    `/exam-seating/students-for-schedule/${scheduleId}${qs(filters)}`
  );
  return res.data;
};

export const updateSeatingPlan = async (id, data) => {
  const res = await axiosInstance.put(`/exam-seating/update/${id}`, data);
  return res.data;
};

export const updateSeatingPlanStatus = async (id, status) => {
  const res = await axiosInstance.put(`/exam-seating/status/${id}`, { status });
  return res.data;
};

export const deleteSeatingPlan = async (id) => {
  const res = await axiosInstance.delete(`/exam-seating/delete/${id}`);
  return res.data;
};
